import { render, staticRenderFns } from "./aboutUs.vue?vue&type=template&id=773e967e&scoped=true"
import script from "./aboutUs.vue?vue&type=script&lang=js"
export * from "./aboutUs.vue?vue&type=script&lang=js"
import style0 from "./aboutUs.vue?vue&type=style&index=0&id=773e967e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773e967e",
  null
  
)

export default component.exports